/**
 * 公用配置类
 * @type {{
   baseURL: string 请求地址
   dialogDetail: object 
   details: array 
   }}
 */
const global = {
    baseURL: 'https://vr.naveco.com.cn/server',
    // 
    // baseURL: 'http://8.142.217.137:8090/eureka',
    //个人信息保护声明
    dialogDetail: {
        title: "个人信息保护声明",
        titleText: '保护用户个人信息是南京依维柯的一项基本原则。南京依维柯将按照本声明及《隐私政策》的规定收集使用、储存和分享您的个人信息。本声明对个人信息保护规定的内容与上述《隐私政策》相冲突的，及本声明对个人信息保护相关內容未作明确规定的，以《隐私政策》的内容为准。',
        details: [
            '一、个人信息的收集', '1、我们收集您的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验，我们仅收集与为您提供产品、服务有关的信息，包括：', '①姓名', '②移动电话',
            '③您在网站的表格上输入的其他信息(电子邮箱、车牌号、住址等)', '④在您上载到网站的内容中包含的个人信息', '⑤根据法律规定，其他能够单独或者与其他信息结合识别您个人身份的信息',
            '2、以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品、服务造成一定的影响。',
            '3、对于不满18岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。', "二、个人信息的使用和分享",
            '您同意，南京依维柯可以通过以下方式对个人信息进行使用和分享(包含对于个人信息的存储和处理)；', '我们和关联公司在合法正当的范围内使用；', '我们向相关汽车经销商、厂商及集团分享并由其在合法正当的范围內使用；',
            '我们及关联公司及相关汽车经销商、厂商及集团为满足您的需求，可能通过您提供的信息与您联系；', '我们及关联公司及相关汽车经销商、厂商及集团可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。',
            '若我们拟将信息用于其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。',
            '您同意免除上述个人信息的接收和/或使用方在按照本声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。', '三、更正或投诉',
            '如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，您可以拨打电话400-828-1890联系我们。'
        ]
    }
}
export default global


// WEBPACK FOOTER //
// ./src/assets/js/global.js